import { Navigate, useLocation } from "react-router-dom";

/**
 * Sends a retired payment entry point to the /book-service request page with
 * the matching service preselected. Campaign parameters on the original URL
 * are kept; the original service/brand/symptom/installer context is kept and saved
 * with the request (never sent to analytics).
 */
const RESCUE_SERVICE_MAP: Record<string, string> = {
  "post-install-inspection": "solar-inspection",
  "pto-signoff": "solar-inspection",
};

export default function RequestRedirect({ category }: { category: string }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  // The original `service` stays in the URL as context (e.g. system-takeover);
  // only the request selection is set here.
  const svc = (params.get("service") || "").toLowerCase();
  params.set("category", RESCUE_SERVICE_MAP[svc] ?? category);
  return <Navigate to={`/book-service?${params.toString()}`} replace />;
}
